// import "./EmployeDiractory.scss";
import { Button } from "@mui/material";
import React from "react";
import AddEmpolyeeModal from "./add-employee/addEmployeeModal";

const EmployeDiractory = () => {
  const [addEmplyeeModalOpen, setAddEmplyeeModalOpen] = React.useState<boolean>(false);

  return (
    <div>
      
      <Button onClick={() => setAddEmplyeeModalOpen(true)}>
        Add Employee
      </Button>
      <AddEmpolyeeModal setOpenModal={setAddEmplyeeModalOpen} openModal={addEmplyeeModalOpen} />
    </div>

  );
};

export default EmployeDiractory;
